import React from "react";
import { motion } from "framer-motion";

function LogoNav() {
  return (
    <div className="p-5 flex justify-center items-center rounded-lg">
      <motion.img
        src="https://flowbite.com/docs/images/logo.svg"
        alt="Flowbite Logo"
        className="h-12 w-12 object-contain"
        animate={{
          scale: [1, 1.2, 1.2, 1, 1],
          rotate: [0, 0, 360, 360, 0],
          borderRadius: ["0%", "0%", "50%", "50%", "0%"],
        }}
        transition={{
          duration: 3,
          ease: "easeInOut",
          times: [0, 0.2, 0.5, 0.8, 1],
          repeat: Infinity,
          repeatDelay: 1,
        }}
      />
    </div>
  );
}

export default LogoNav;
